import React, { Fragment, useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Button, IconButton } from "@material-ui/core";
import StarIcon from "../../../src/images/star icon.png";

import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import ReactGA from "react-ga4";

import { HeaderContainer } from "./styles/index.style";
import authActions from "../../redux/actions/auth";
import {
  Account,
  Logo,
  Faq,
  Pricing,
  TheWire,
  Cart,
  Categories,
  CategoriesElastic,
  Collections,
  SearchEngineToggle
} from "./component";
import { Display } from "../../helpers/index";
import { Mixpanel } from "../shared/Mixpanel";
import selectRMuser from "../../redux/reselect/cart/selectRMuser";
import Drawer from "./component/Drawer";
import SearchBar from "./component/SearchBar";
import useWindow from "../../hooks/useWindow";
import Analytics from "../../helpers/analytics";

import CATEGORIES from "../../misc/categories";
import { slugify } from "../../redux/reselect/collections";

const { logoutRequest } = authActions;

function Header(props) {
  const screen = useWindow();
  const {
    auth,
    user,
    match,
    search,
    location,
    history,
    getSearchResults,
    headerSticky,
    removeFromCart,
    getUserInfo,
    fetchingCheckout,
    getCategoriesList,
    logoutRequest,
    clearAllSearch
  } = props;

  const [state, setState] = React.useState({
    onScroll: false,
    searchInputValue: "",
    formError: false,
    showMobileMenu: false
  });

  const [showMobileSearch, setShowMobileSearch] = React.useState(false);
  const [algoliaSearch, setAlgoliaSearch] = React.useState(
    localStorage.getItem("algoliaSearch") === "true"
  );
  const slugCategory = CATEGORIES.map((item) => slugify(item));
  const paths = location.pathname.split("/");
  const { isMobile } = useWindow(550);
  const totalResults = useSelector((state) => state?.pages?.search);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    setState((prev) => ({
      ...prev,
      onScroll: scrollTop > 0
    }));
  };

  const handleSearchFieldChange = (event) => {
    const { value } = event.target;
    setState((prev) => ({
      ...prev,
      searchInputValue: value,
      formError: false
    }));
  };

  const handleSearchFormSubmit = () => {
    const { history } = props;

    if (state.searchInputValue !== "") {
      props.clearAllSearch();
      Analytics.track("TopSearch", {
        category: "LP-TopNav",
        label: "Search"
      });

      Analytics.track(state.searchInputValue.trim(), {
        category: "LP-SearchTerm",
        label: "Search"
      });

      ReactGA.ga(
        "send",
        "pageview",
        window.location.pathname + "?q=" + state.searchInputValue.trim()
      );

      Mixpanel.track("Perform Search", {
        "Search Term": state.searchInputValue.trim()
      });
      setState((prev) => ({
        ...prev,
        formError: false
      }));
      history.push(`/licensing/search?q=${state.searchInputValue.trim()}`);
    } else {
      Analytics.track("TopSearch", {
        category: "LP-TopNav",
        label: "EmptySearch"
      });

      Analytics.track("null_search", {
        category: "LP_search",
        label: "LP_nullsearch",
        search_type: "Null search",
        search_keyword: "N/A",
        total_number_of_search_results: totalResults?.pagination?.totalResults
      });
      setState((prev) => ({ ...prev, formError: true }));
    }
  };

  const handleLogout = () => logoutRequest();

  const onMobileNavMenuClick = () =>
    setState((prev) => ({ ...prev, showMobileMenu: !state.showMobileMenu }));

  const isMatch = (param) => match.path.startsWith(param);

  const toggleMobileSearch = () => {
    if (showMobileSearch) setState((prev) => ({ ...prev, searchInputValue: "" }));
    setShowMobileSearch(!showMobileSearch);
  };

  const onClickGoToHome = (e) => {
    if (location.pathname === "/licensing") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  React.useEffect(() => {
    getUserInfo(auth);
    window.addEventListener("scroll", handleScroll);

    getCategoriesList(user.searchParams);

    if (document.getElementsByClassName("footerUrl")[4]) {
      document.getElementsByClassName("footerUrl")[4].innerText == "Submit Video"
        ? (document.getElementsByClassName("footerUrl")[4].href =
            "https://jukinmedia.com/licensing/video-submissions")
        : (document.getElementsByClassName("footerUrl")[5].href =
            "https://jukinmedia.com/licensing/video-submissions");
    }

    let footerCopyright = document.getElementsByClassName("footerCopyright")[0];
    let footerUrl = document.getElementsByClassName("footerUrl");

    if (footerCopyright) footerCopyright.href = "https://www.trustedmediabrands.com";

    // if (window.innerWidth < 700) document.getElementsByClassName('mobileLogo')[0].href = 'https://www.trustedmediabrands.com';

    for (let key in footerUrl) {
      if (footerUrl[key].innerText == "About") {
        footerUrl[key].href = "https://www.trustedmediabrands.com/about";
      }

      if (footerUrl[key].innerText == "Brands") {
        footerUrl[key].href = "https://www.trustedmediabrands.com/our-brands";
      }

      if (footerUrl[key].innerText == "Privacy Policy") {
        footerUrl[key].href = "https://www.jukinmedia.com/licensing/privacy-policy";
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "Terms") {
        footerUrl[key].href = "https://www.jukinmedia.com/licensing/terms";
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "Work With Us") {
        footerUrl[key].href = "https://www.jukinmedia.com/licensing/why-work-with-jukin";
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "IP Form") {
        footerUrl[key].href = "https://www.jukinmedia.com/licensing/reported-infringement";
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "FAQ") {
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "Submit Inquiry") {
        footerUrl[key].target = "_blank";
      }

      if (footerUrl[key].innerText == "Submit Video") {
        footerUrl[key].target = "_blank";
      }
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const startsWith = (loc) => location.pathname.startsWith(loc);

  const hideSearchIcon = startsWith("/licensing/search");

  const isInAdmin =
    startsWith("/licensing/account/merchandising") || startsWith("/licensing/account/publisher");
  const isInside = auth?.user?.roles?.includes("ROLE_INSIDER");
  const isRiff = auth?.user?.roles?.includes("ROLE_RIFF_USER");
  const hideInUserPanne = isInAdmin && (isRiff || isInside);

  const handleClick = (e) => {
    Analytics.track("search_bar_click", {
      category: "LP_search",
      label: "search_bar_allpages"
    });
  };

  return (
    <HeaderContainer
      id="navigation"
      scrolling={!headerSticky ? "true" : `${state.onScroll || showMobileSearch}`}
      className={classnames({
        hidden: props.headerHidden,
        "mobile--search-active": showMobileSearch
      })}
    >
      {!hideInUserPanne && <Logo />}

      {screen.width <= 991 && (
        <Fragment>
          <IconButton
            id="mobile-nav-button"
            className="mini-nav-button dark"
            onClick={onMobileNavMenuClick}
          >
            <MenuIcon />
          </IconButton>
          {showMobileSearch ? (
            <form
              className="mobile--search-bar"
              autoComplete="off"
              onSubmit={handleSearchFormSubmit}
            >
              <SearchEngineToggle />
              {!algoliaSearch ? (
                <div className="input-wrapper">
                  <input
                    id="topSearchBox"
                    name="q"
                    placeholder={
                      isMobile
                        ? "Search with AI"
                        : "Search with AI (try JVID or keyword e.g. funny cat)"
                    }
                    value={state.searchInputValue}
                    onChange={handleSearchFieldChange}
                    onClick={handleClick}
                  />
                </div>
              ) : (
                <input
                  id="topSearchBox"
                  name="q"
                  placeholder="Try JVID or keyword e.g funny cat"
                  value={state.searchInputValue}
                  onChange={handleSearchFieldChange}
                  onClick={handleClick}
                />
              )}
              <input type="submit" className="hidden" />
              {!isMobile && (
                <Button type="submit" className={classnames("button__submit")}>
                  <SearchIcon onClick={handleSearchFormSubmit} />
                </Button>
              )}
            </form>
          ) : (
            screen.width !== 991 && (
              <h2 className="brand--name">
                <Link id="home-link" to="/licensing" onClick={onClickGoToHome}>
                  Jukin Licensing
                </Link>
              </h2>
            )
          )}
          {!hideSearchIcon ? (
            <IconButton
              id="mobile-search-toggle"
              className="mini-nav-button dark"
              onClick={toggleMobileSearch}
            >
              {showMobileSearch ? (
                <CloseIcon />
              ) : (
                <Button className="search__submit">
                  <SearchIcon fontSize="20px"></SearchIcon>
                </Button>
              )}
            </IconButton>
          ) : (
            <div style={{ width: 48 }} />
          )}

          <Drawer
            open={state.showMobileMenu}
            onClose={onMobileNavMenuClick}
            categories={search.categoryList}
            clearAllSearch={clearAllSearch}
            handleLogout={handleLogout}
            location={location}
            auth={auth}
            getSearchResults={getSearchResults}
            search={search}
          />
        </Fragment>
      )}

      {screen.width >= 992 && process.env.PAGE !== "search" && !hideInUserPanne && (
        <SearchBar
          headerSticky={headerSticky}
          onScroll={state.onScroll}
          auth={auth}
          clearAllSearch={clearAllSearch}
          location={location}
          history={history}
        />
      )}

      <section className="lp-cart-account">
        <div className="mobileMenu">
          <div style={{ zIndex: "2" }} className="lp-nav-container lp-cart-dropdown">
            <div
              className={classnames("lp-nav-item", {
                active: slugCategory.includes(paths[3])
              })}
            >
              {process.env.REACT_APP_ALGOLIA_ENABLE === "true" ? (
                <Categories scrolling={!headerSticky ? "true" : `${state.onScroll}`} {...props} />
              ) : (
                <CategoriesElastic
                  scrolling={!headerSticky ? "true" : `${state.onScroll}`}
                  {...props}
                />
              )}
            </div>

            <div
              className={classnames("lp-nav-item", {
                active:
                  match.path === "/licensing/collections" ||
                  (paths[2] === "collections" && paths[3] && !slugCategory.includes(paths[3]))
              })}
            >
              <Collections />
            </div>

            <div
              className={classnames("lp-nav-item", {
                active: isMatch("/licensing/faq")
              })}
            >
              <Faq />
            </div>

            <div
              className={classnames("lp-nav-item", {
                active: isMatch("/licensing/pricing")
              })}
            >
              <Pricing {...props} />
            </div>

            <div
              className={classnames("lp-nav-item", {
                active: isMatch("/licensing/thewire")
              })}
            >
              <TheWire />
            </div>

            <div className="lp-nav-item">
              <Link
                to="/licensing/inquiry"
                onClick={() => {
                  localStorage.setItem("prevPath", props.location.pathname);
                  Analytics.track("Contact Us", {
                    category: "LP-TopNav"
                  });
                }}
              >
                <Button>Contact Us</Button>
              </Link>
            </div>

            <div className="lp-nav-item">
              <Link
                to="/licensing/video-submissions"
                onClick={() => {
                  localStorage.setItem("prevPath", props.location.pathname);
                  Analytics.track("Submit Video", {
                    category: "LP-TopNav"
                  });
                }}
              >
                <Button>Submit Video</Button>
              </Link>
            </div>

            <div className="lp-nav-item">
              <Cart auth={auth} user={user} removeFromCart={removeFromCart} {...props} />
            </div>

            <Display if={auth.loggedIn}>
              <div className="lp-nav-item">
                <Account
                  logout={handleLogout}
                  playlist={user.listsCount}
                  scrolling={!headerSticky ? "true" : `${state.onScroll}`}
                />
              </div>
            </Display>

            <Display if={!auth.loggedIn}>
              <div className="lp-nav-item">
                <Link
                  to="/licensing/login"
                  onClick={() => {
                    localStorage.setItem("prevPath", props.location.pathname);
                    Analytics.track("SignIn", {
                      category: "LP-TopNav"
                    });
                  }}
                >
                  <Button className="top-nav-bt signin">Sign In</Button>
                </Link>
              </div>
              <div className="lp-nav-item">
                <Link
                  to="/licensing/register"
                  onClick={() => {
                    localStorage.setItem("prevPath", props.location.pathname);
                    Analytics.track("SignUp", {
                      category: "LP-TopNav"
                    });
                  }}
                >
                  <Button className="top-nav-bt signup">Sign Up</Button>
                </Link>
              </div>
            </Display>
          </div>
        </div>
      </section>
    </HeaderContainer>
  );
}

Header.propTypes = {
  headerSticky: PropTypes.bool
};

Header.defaultProps = {
  headerSticky: false
};

const mapStateToProps = ({ auth, user, router }) => ({ auth, user, router });

const mapDispatchToProps = (dispatch) => ({
  logoutRequest: () => dispatch(logoutRequest())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
